import { Subject } from 'rxjs';
import * as LX from '@utils/lxWrapper';

import store from '../../store';

import { OrderNotification, MessageNotification } from '../../store/models/pushNotification';

const addOrderNotification = (orderNotification: OrderNotification) => {
    store.dispatch({ type: 'pushNotification/addOrderNotification', payload: orderNotification });
};

const addWeakNotification = (weakNotification: MessageNotification) => {
    store.dispatch({ type: 'pushNotification/addWeakNotification', payload: weakNotification });
};

const addStrongNotification = (strongNotification: MessageNotification) => {
    store.dispatch({ type: 'pushNotification/addStrongNotification', payload: strongNotification });
};

const ruleCenterSceneCodeLxSubject = new Subject<string | number>();

ruleCenterSceneCodeLxSubject.subscribe(sceneCode => {
    const code = Number(sceneCode);
    if (code === 1) {
        LX.reportMV('b_waimai_e_mg20n10k_mv', 'c_waimai_e_skd9mojn');
    } else if (code === 2) {
        LX.reportMV('b_waimai_e_rlc49loz_mv', 'c_waimai_e_y62il3v6');
    }
});

export {
    addOrderNotification,
    addWeakNotification,
    addStrongNotification,
    MessageNotification,
    ruleCenterSceneCodeLxSubject,
};
